import { lazy } from 'react'

export const StickingPlan = lazy(() => import('./v1/StickingPlan'))
export const StickingPlanV2 = lazy(() => import('./v2/StickingPlanV2'))
